
//无线滚动思路：
//属性
//v-dt-infinite-scroll 获取新内容（getData）方法
//dt-infinite-reminder-wrapper css选择器，用来放置“加载中”文字
//dt-infinite-disabled 若为true，则滚动加载不触发
//
//getData(page)规则：
//获取数据并展示出来
//返回一个promise对象 数据加载完后设置为resolve状态 以便继续监听滚动事件 如果如果promise状态变为reject 视为已没有更多数据 停止监听滚动
//参数page初始为1，每次调用getData后都会递增


//
//init：
//循环执行getData方法，直到内容超出容器，或者dt-infinite-disabled为false（已无新内容时可以将其设置为false）。
//
//监听滚动事件，滚动到底部后执行getData方法。
//
//循环执行数据读取时不显示加载中（但是预留能显示下“加载中”的空白）。加载好后，再滑到最底部显示加载中并加载。
//getData返回一个Promise。执行getData前自动将dt-infinite-disabled设置为true，Promise resolve后设置为false
//
//执行getData方法时，传入一个数字，从1开始，每次递增


const o="dt-infinite-scroll"
var obj={
	reminderWrapper:null,
	reminderEl:null,
	page:1,
	getDataFunc:null,
	changeSign:null,
	father:null,
}
//找到最近的滚动元素
var getScrollElement=function(element){
	var currentNode=element;
	while(currentNode && currentNode.nodeName !=="BODY" && currentNode.nodeName !=="HTML" && currentNode.nodeType===1){
		var overflowY=getComputedStyle(currentNode).overflowY;
		if(overflowY==="scroll" || overflowY==="auto"){
			return currentNode;
		}
		currentNode=currentNode.parentNode;
	}
	return window;
};
//检测scrollEl可以滚动的距离大于loading提示的高度
//也就是检测是否scrollEl减去其父元素高度大于loading提示的高度
//父元素要用clientHeight，而子元素要用offsetHeight
var checkScrollStatus=function(element){
	var loadHeight=30;
	var father=getScrollElement(element);
	if(element.offsetHeight-getClientHeight(father)>loadHeight)
		return true;
	else
		return false;
};
var getClientHeight=function(element){
	if(element==window){
		return window.innerHeight;
	}
	else{
		return element.clientHeight;
	}
};
var getScrollTop=function(element){
	if(element==window){
		return window.pageYOffset;
	}
	else{
		return element.scrollTop;
	}
};
//循环执行getData直到状态A
var getData=function(element,binding){
	var promise;
	if(checkScrollStatus(element)){
		doBind.call(this,element,binding);
	}
	else{
		promise=this.getDataFunc(this.page++);
		promise.then(res=>{
			getData.call(this,element,binding);
		},res=>{})
	}
};
//滚动时执行
var func=function(){
  if(this.disabled) return;
	var father=this.father;
	var element=this.element;
	//滚动到触发加载的距离
	if(getClientHeight(father)+getScrollTop(father)>element.offsetHeight-30){
		this.reminderWrapper.appendChild(this.reminderEl);
		unBind.call(this,arguments);
		var promise;
		promise=this.getDataFunc(this.page++);
		promise.then(res=>{
			doBind.call(this,arguments);
		},res=>{
		  //返回reject时不做处理，进为了浏览器不提醒
    }).finally(()=>{
			this.reminderWrapper.removeChild(this.reminderEl);
		})
	}
}
//给scrollEl绑定scroll事件，滚动到底时触发方法
//显示loading提示，然后循环执行getData直到状态A，隐藏loading提示
var doBind=function(){
	this.father.addEventListener("scroll",this.func);
};
var unBind=function(){
	this.father.removeEventListener("scroll",this.func);
}
var init=function(el,binding,v,oldV){
	if(this.father){
		unBind.apply(this,arguments)
	}
	//将getData保存起来。
	this.getDataFunc=binding.value;
	this.func=func.bind(this);

	this.page=1;
	this.father=getScrollElement(el);
	this.element=el;

	//保存是否允许触发
  this.disabled=el.getAttribute('dt-infinite-disabled');

	//状态A：scrollEl可以滚动的距离大于loading提示的高度
	//循环执行getData直到状态A
	getData.call(this,el,binding);
	var defineWrapperSelector=el.getAttribute('dt-infinite-reminder-wrapper');
	if(defineWrapperSelector){
		this.reminderWrapper=document.querySelector(defineWrapperSelector);
	}
	else{
		this.reminderWrapper=el.parentNode;
	}
}
export default{
	bind:function(el,binding,v,oldV){
		v.context.$nextTick(()=>{
			el[o]=el[o]||{};
			el[o].changeSign=el.getAttribute('change-sign');

			//创建“加载中”文字
			// var isPhone=/Android|webOS|iPhone|iPod|BlackBerry|HarmonyOS/i.test(navigator.userAgent);
      const ua = navigator.userAgent || '';
      var isPhone = /Mobile|Android|iPhone|iPod|webOS|BlackBerry|iPad|Tablet/i.test(ua);
			var text=document.createTextNode("加载中");
			var reminderEl=document.createElement("div");
			reminderEl.appendChild(text);
			reminderEl.style.textAlign="center";
			reminderEl.style.lineHeight=isPhone ? "-20px" : "30px";
			reminderEl.style.marginBottom=isPhone ? "-20px" : "-30px";
			reminderEl.style.fontSize=isPhone ? "14px" : "20px";
			el[o].reminderEl=reminderEl;

			init.apply(el[o],arguments);
		})
	},
	componentUpdated:function(el,binding,v,oldV){
		//需要重新初始化
		if(el[o].changeSign!=el.getAttribute('change-sign')){
			el[o].changeSign=el.getAttribute('change-sign');
			init.apply(el[o],arguments);
		}
		if(el[o].disabled!=el.getAttribute('dt-infinite-disabled')){
      el[o].disabled=el.getAttribute('dt-infinite-disabled');
    }
	},
	unbind:(el,binding,v,oldV)=>{
		el[o].page=1;
		unBind.apply(el[o],arguments);
	}
}



// WEBPACK FOOTER //
// ./src/util/dt-infinite-scroll/dt-infinite-scroll.js